import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActionService } from '../services/action.service';
import { JsonPipe } from '@angular/common';
import { DatePipe } from '@angular/common/src/pipes/date_pipe';
import { RouterModule } from '@angular/router/';

@Component({
  selector: 'lib-html-command-button',
  templateUrl: './html-command-button.component.html',
  styleUrls: ['./html-command-button.component.css']
})
export class HtmlCommandButtonComponent implements OnInit {
  @Input() jsonObject: any;
  @Input() layoutObject: any;
  @Input() complexElementBeanClass: string = '';
  @Input() simpleElementBeanClass: string = '';
  @Input() complexElementBeanId: string = '';
  @Input() complexListVarId: string = ''
  @Input() isEnable;
  @Input() listVarCount: number;
  @Input() tableListVarCount: number;
  @Input() outputModelName: string;
  @Input() tableListVarId: string;
  @Input() worklistIcon: boolean;
  @Input() tableFlag: boolean;
  @Input() headerFlag: boolean;
  @Input() dynamicElements: boolean;
  @Input() toggleData: boolean;
  @Input() queryGrid: boolean;
  @Input() columnSearch: boolean;
  @Input() columnSort: boolean;
  @Input() columnList: string;

  @Output() clickEvent = new EventEmitter();

  _required: boolean;
  updatedString: string = '';
  btnString: string = '';
  cnt_toggle: number;

  constructor(public action: ActionService) {

  }

  ngOnInit() {
    //this.btnString = htmlCommandButton(this.jsonObject, this.layoutObject, '');
    if (this.jsonObject['beanClass'] != undefined && this.jsonObject['beanClass'] != '') {
      this.simpleElementBeanClass = this.jsonObject['beanClass'];
    } else if (this.complexElementBeanClass != undefined && this.complexElementBeanClass != '') {
      this.simpleElementBeanClass = this.complexElementBeanClass;
    } else if (this.complexElementBeanClass != undefined && this.complexElementBeanClass != '') {
      this.simpleElementBeanClass = this.complexElementBeanClass;
    }

    if (this.jsonObject['columnSearch'] != undefined && this.jsonObject['columnSearch'] == true) {
      if (this.layoutObject['table_' + this.simpleElementBeanClass] == undefined && this.jsonObject['beanId']) {
        this.layoutObject['table_' + this.simpleElementBeanClass] = {};
        if (this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId] == undefined) {
          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId] = {};
        }
      }

      if (this.layoutObject['table_' + this.complexElementBeanClass]) {
        this.layoutObject['table_' + this.complexElementBeanClass][this.complexElementBeanId]['columnSearch'] = this.jsonObject.columnSearch;
      }

      if (this.complexElementBeanId) {
        this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['ajax_method'] = this.jsonObject.ajaxCall.ajaxListenerMethod;
        this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['ajax_method_type'] = this.jsonObject.ajaxCall.methodType;
        this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['componentId'] = this.jsonObject.id;
        this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['noOfRecords'] = this.jsonObject.noOfRecords;
      }
    }

    if (this.layoutObject['table_' + this.complexElementBeanClass]) {
      if (this.jsonObject['saveMySettings'] && this.jsonObject.saveMySettings == true) {
        this.layoutObject['table_' + this.complexElementBeanClass][this.complexElementBeanId]['saveMySettings'] = true;
      }

      if (this.jsonObject.uiSearchAll == true && this.layoutObject['table_' + this.complexElementBeanClass]) {
        this.layoutObject['table_' + this.complexElementBeanClass][this.complexElementBeanId]['uiSearchAll'] = this.jsonObject.uiSearchAll;
      }
    }

    if (this.queryGrid == true) {
      this.layoutObject['queryGrid_' + this.complexElementBeanClass][this.complexElementBeanId]['gridHeadsArray'].push({
        "id": this.jsonObject.beanId,
        "col_id": this.jsonObject.beanId,
        "name": this.jsonObject.name,
        "styleClass": this.jsonObject.styleClass,
        "type": this.jsonObject.type,
        "elementObj": this.jsonObject,
        "complexElementBeanClass": this.simpleElementBeanClass,
        "complexElementBeanId": this.complexElementBeanId
      });
    }

    if (this.worklistIcon == true) {

      if (!this.layoutObject.hasOwnProperty('table_' + this.complexElementBeanClass)) {
        this.layoutObject['table_' + this.complexElementBeanClass] = {};
      }

      if (!this.layoutObject['table_' + this.complexElementBeanClass].hasOwnProperty(this.complexElementBeanId)) {
        this.layoutObject['table_' + this.complexElementBeanClass][this.complexElementBeanId] = {};
      }
    }

    if (this.tableFlag == true) {
      if (this.jsonObject.hasOwnProperty('configureColumn') && this.jsonObject.configureColumn == false && this.jsonObject.hasOwnProperty('default_visible') && this.jsonObject.default_visible == false) {

      } else {

        if (this.tableListVarId != "") {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['tableHeadsArray']
            .push({
              "id": this.jsonObject.beanId,
              "col_id": this.jsonObject.colId,
              "method": this.jsonObject.actionListenerMethod,
              "name": this.jsonObject.label,
              "styleClass": this.jsonObject.styleClass,
              "columnSearch": this.columnSearch,
              "columnSort": this.columnSort ? this.columnSort : this.jsonObject.columnSort,
              "searchTermModel": "searchItem_" + this.jsonObject.beanId,
              "tableSizerId": this.jsonObject.beanId + "-sizer",
              "type": this.jsonObject.type,
              "elementObj": this.jsonObject,
              "complexElementBeanClass": this.simpleElementBeanClass,
              "complexElementBeanId": this.complexElementBeanId
            });
        } else {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['tableHeadsArray']
            .push({
              "id": this.jsonObject.beanId,
              "col_id": this.jsonObject.colId,
              "method": this.jsonObject.actionListenerMethod,
              "name": this.jsonObject.label,
              "styleClass": this.jsonObject.styleClass,
              "columnSearch": this.columnSearch,
              "columnSort": this.columnSort ? this.columnSort : this.jsonObject.columnSort,
              "searchTermModel": "searchItem_" + this.jsonObject.beanId,
              "tableSizerId": this.jsonObject.beanId + "-sizer",
              "type": this.jsonObject.type,
              "elementObj": this.jsonObject,
              "complexElementBeanClass": this.simpleElementBeanClass,
              "complexElementBeanId": this.complexElementBeanId
            });
        }
      }

      if (this.tableListVarId != "") {

        if (this.jsonObject.configureColumn == true) {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['columnVisibility'][this.jsonObject.colId] = true;
          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['columnToggleArray']
            .push({
              "id": this.jsonObject.beanId,
              "col_id": this.jsonObject.colId,
              "name": this.jsonObject.label,
              "assignable": true
            });
          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['defaultCol']
            .push(this.jsonObject.colId);
        } else {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['columnVisibility'][this.jsonObject.colId] = false;
        }

        if (this.jsonObject.hasOwnProperty('default_visible')) {
          if (this.jsonObject.default_visible == true) {
            this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['selected_items_id']
              .push(this.jsonObject.colId);
          }
        } else {
          this.layoutObject['table_' + this.simpleElementBeanClass][this.tableListVarId][this.tableListVarCount][this.complexElementBeanId]['selected_items_id']
            .push(this.jsonObject.colId);
        }
      } else {
        if (this.jsonObject.configureColumn == true) {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['columnVisibility'][this.jsonObject.colId] = true;
          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['columnToggleArray']
            .push({
              "id": this.jsonObject.beanId,
              "col_id": this.jsonObject.colId,
              "name": this.jsonObject.label,
              "assignable": true
            });
          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['defaultCol']
            .push(this.jsonObject.colId);
        } else {

          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['columnVisibility'][this.jsonObject.colId] = false;
        }

        if (this.jsonObject.hasOwnProperty('default_visible')) {
          if (this.jsonObject.default_visible == true) {
            this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['selected_items_id']
              .push(this.jsonObject.colId);
          }
        } else {
          this.layoutObject['table_' + this.simpleElementBeanClass][this.complexElementBeanId]['selected_items_id']
            .push(this.jsonObject.colId);
        }
      }
    }
  }

  updateLayoutObject($event) {
    this.layoutObject['worklisttab']['libraryObject'] = 'Wahid Shaikh library';
    console.log('Emitted from command link to simple element : ' + this.layoutObject);
    this.clickEvent.emit(this.layoutObject);
  }

  search() {

  }

  toggleGlobalSearch() {

  }

  saveData() {

  }

  exportDataToExcel() {

  }

  toggleSearchRow() {

  }

  updatedChangePage($event) {
    this.prepareComponent($event, this.jsonObject, this.layoutObject, false);
  }

  addRow(fromBeanClass, fromBeanId, toBeanClass, toBeanId, removeFromBase, selectedRowTableId, targetBeanCountBeanClass, targetBeanCountBeanId) {
    console.log('Row Added!');
  }

  clearFields = function (beanClasses, beanIds) {

    var arrBeanClass = beanClasses.split('=');
    var arrBeanIds = beanIds.split('=');

    if (arrBeanClass && arrBeanClass != '') {

      for (var x = 0; x < arrBeanClass.length; x++) {

        var innerBeanIds = arrBeanIds[x].split(',');
        if (arrBeanIds[x] == 'clearAll') {
          var beanClassDefault = this.layoutObject.responseData.ValueJson[arrBeanClass[x]];
          beanClassDefault.forEach((key, value) => {

            if (value != "true" && value != "false" && value != "Cancelled") {
              if (typeof value == "object") {

                this.layoutObject.responseData.ValueJson[arrBeanClass[x]][key] = {};
              }
              /*else if (typeof (value) == "array") {

                this.layoutObject.responseData.ValueJson[arrBeanClass[x]][key] = [];
              }*/
              else if (typeof value == "boolean") {

                this.layoutObject.responseData.ValueJson[arrBeanClass[x]][key] = false;
              }
              else {

                this.layoutObject.responseData.ValueJson[arrBeanClass[x]][key] = '';
              }
            }
          });
        } else {

          for (var j = 0; j < innerBeanIds.length; j++) {

            if (typeof (this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]]) == "object") {

              this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]] = {};

            }
            /* else if (typeof (this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]]) == "array") {

              this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]] = [];
            }*/
            else if (typeof (this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]]) == "boolean") {

              this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]] = false;
            } else {

              this.layoutObject.responseData.ValueJson[arrBeanClass[x]][innerBeanIds[j]] = '';
            }
          }
        }
      }
    }
  }

  resetFields(jsonObj: any) {
    var beanClasses = '';
    var beanIds = '';
    for (var i = 0; i < jsonObj.resetBeanDetails.resetBeans.resetBean.length; i++) {
      if (jsonObj.resetBeanDetails.resetBeans.resetBean[i].beanClass && jsonObj.resetBeanDetails.resetBeans.resetBean[i].beanClass != '') {
        if (beanClasses != '' && beanIds != '') {

          beanClasses = beanClasses + '=';
          beanClasses = beanClasses + '=';
        }

        beanClasses = jsonObj.resetBeanDetails.resetBeans.resetBean[i].beanClass;

        if (jsonObj.resetBeanDetails.resetBeans.resetBean[i].beanId == '') {
          beanIds = 'clearAll'
        } else {

          beanIds = jsonObj.resetBeanDetails.resetBeans.resetBean[i].beanId;
        }
      }
    }

    this.clearFields(beanClasses, beanIds);
  }

  autoRefreshToggleBtnClick() {
    console.log('autoRefreshToggleBtnClick');
  }

  prepareComponent($event, jsonObj: any, layoutObject: any, _required?: boolean, isEnable?: boolean): void {
    var confirmObj = {};

    if (this.complexElementBeanClass != "") {
      this.simpleElementBeanClass = this.complexElementBeanClass;
    } else {
      this.simpleElementBeanClass = this.outputModelName;
    }

    if (jsonObj['beanClass']) {
      this.simpleElementBeanClass = jsonObj['beanClass'];
    }

    var immediate = false;
    var mandatoryComplex = '';
    if (jsonObj.hasOwnProperty('immediate') && jsonObj.immediate == true) {
      immediate = true;

      if (jsonObj.hasOwnProperty('mandatoryComplex') && jsonObj.mandatoryComplex.hasOwnProperty('referenceID')) {
        mandatoryComplex = jsonObj.mandatoryComplex.referenceID;
      }
    }

    if (jsonObj.hasOwnProperty('isConfirm') && jsonObj.isConfirm == true) {
      confirmObj["isConfirm"] = jsonObj.isConfirm;
      if (jsonObj.hasOwnProperty('confirmMessage') && jsonObj.confirmMessage != "") {
        confirmObj["confirmMessage"] = jsonObj.confirmMessage;
      } else {
        confirmObj["confirmMessage"] = "";
      }
    }

    if (jsonObj.hasOwnProperty('targetID')) {
      layoutObject.responseData.ValueJson[this.simpleElementBeanClass][jsonObj.description + '_targetID'] = jsonObj.targetID;
    }

    var formChanged = false;
    if ((jsonObj.hasOwnProperty('formChanged') && jsonObj.formChanged == true) && (jsonObj.hasOwnProperty('ajaxCall') && jsonObj.ajaxCall.hasOwnProperty('formChanged') && jsonObj.ajaxCall.formChanged == true)) {
      formChanged = true;
    }

    var ajaxSectionIds, sectionIds, ajaxRemoveIds, ajaxAddIds, ajax_params, refValue, addIds, removeIds, action, targetBeanClass, targetBeanId = '';
    var ajaxRender = '';
    var method = "";
    var params = '';
    var checkBeanClass = "";
    var fullData = false;
    var renderSec = "";
    var ajaxTargetBeans = '';
    var ajaxAddRemoveElems = "";
    var ajax_msgValue = "";

    if (jsonObj.hasOwnProperty('ajaxCall') && jsonObj.ajaxCall.hasOwnProperty('isFullData')) {
      fullData = jsonObj.ajaxCall.isFullData;
    }

    var method_type = 'POST';
    if (jsonObj.hasOwnProperty('methodType')) {
      method_type = jsonObj.methodType;
    }

    if (jsonObj.hasOwnProperty('actionListenerMethod')) {
      method = jsonObj.actionListenerMethod;
    }

    //#region AjaxCall
    if (jsonObj.hasOwnProperty('isAjaxCall') && jsonObj.isAjaxCall == true) {
      if (jsonObj.hasOwnProperty('ajaxCall')) {
        if (jsonObj.ajaxCall.hasOwnProperty("renderSection")) {
          renderSec = jsonObj.ajaxCall.renderSection;
          if (jsonObj.ajaxCall.hasOwnProperty("targetSections") && jsonObj.ajaxCall.targetSections.hasOwnProperty("targetSection")) {
            jsonObj.ajaxCall.targetSections.targetSection.forEach((y, x) => {
              if (y.hasOwnProperty('referenceValue')) {
                refValue = y['referenceValue'];
              } else {
                refValue = "";
              }

              if (y.hasOwnProperty('action')) {
                action = y['action'];
              } else {
                action = "";
              }

              if (y.hasOwnProperty('targetBeanClass')) {
                targetBeanClass = y['targetBeanClass'];
              } else {
                targetBeanClass = "";
              }

              if (y.hasOwnProperty('targetBeanId')) {
                targetBeanId = y['targetBeanId'];
              } else {
                targetBeanId = "";
              }

              if (y.hasOwnProperty('sectionId')) {
                sectionIds = y['sectionId'];
                if (ajaxSectionIds == undefined || ajaxSectionIds == '') {
                  ajaxSectionIds = y['sectionId'];
                } else {
                  ajaxSectionIds += y['sectionId'];
                }
              }

              if (y.hasOwnProperty('message')) {
                ajax_msgValue = y['message'];
              } else {
                ajax_msgValue = "undefined";
              }

              ajaxTargetBeans = "";
              if (y.hasOwnProperty('targetBean')) {
                y['targetBean'].forEach((targetBean, targetBeanIndx) => {
                  var targetBeanClass = targetBean['targetBeanClass'];
                  var targetBeanId = targetBean['targetBeanId'];
                  var targetValue = targetBean['targetValue'];

                  ajaxTargetBeans += targetBeanClass + "<" + targetBeanId + "<" + targetValue;
                  if (y['targetBean'].length > 1 && targetBeanIndx < y['targetBean'].length - 1) {
                    ajaxTargetBeans += "@";
                  }
                });
              }

              ajaxAddIds = "undefined";
              if (y.hasOwnProperty('add') && y['add'] != undefined && y['add'] != "undefined") {
                if (y['add'].indexOf("All") > -1) {
                  ajaxAddIds += y['add'] + "|" + refValue + "|" + action + "|" + sectionIds;
                } else {
                  addIds = y['add'].split(",");
                  if (addIds.length > 0) {
                    for (var i = 0; i < addIds.length; i++) {
                      if (y.hasOwnProperty('referenceValue')) {
                        if (refValue.indexOf("|") > -1) {

                          var splitedRefVal = refValue.split('|');

                          if (splitedRefVal.length > 0) {
                            ajaxAddIds += addIds[i] + "|" + splitedRefVal[1] + "|" + action + "|" + sectionIds + "|Not|undefined|" + ajax_msgValue;
                          }
                        } else {
                          ajaxAddIds += addIds[i] + "|" + refValue + "|" + action + "|" + sectionIds + "|undefined|undefined|" + ajax_msgValue;
                        }
                      } else {
                        ajaxAddIds += addIds[i] + "|" + "null" + "|" + action + "|" + sectionIds + "|undefined|" + ajaxTargetBeans + "|" + ajax_msgValue;
                      }

                      if (i < addIds.length - 1) {
                        ajaxAddIds += "&";
                      }
                    }
                  }
                }
              }

              ajaxRemoveIds = "undefined";
              if (y.hasOwnProperty('remove')
                && y['remove'] != undefined
                && y['remove'] != "undefined") {
                removeIds = y['remove'].split(",");
                if (removeIds.length > 0) {
                  for (var i = 0; i < removeIds.length; i++) {
                    if (y.hasOwnProperty('referenceValue')) {
                      if (refValue.indexOf("|") > -1) {
                        var splitedRefVal = refValue.split('|');
                        ajaxRemoveIds += removeIds[i] + "|" + splitedRefVal[1] + "|Not";
                      } else {
                        ajaxRemoveIds += removeIds[i] + "|" + refValue;
                      }
                    } else {

                      ajaxRemoveIds += removeIds[i] + "|null|undefined|" + ajaxTargetBeans;
                    }

                    if (i < removeIds.length - 1) {
                      ajaxRemoveIds += "&";
                    }
                  }
                }
              }

              ajaxAddRemoveElems += ajaxAddIds + "^" + ajaxRemoveIds + "^" + action;
              if (x < jsonObj.ajaxCall.targetSections.targetSection.length - 1) {
                ajaxAddRemoveElems += ">";
                ajaxSectionIds += ",";
              }
            });
          }
        }

        if (jsonObj.ajaxCall.hasOwnProperty('ajaxListenerMethod')) {
          method = jsonObj.ajaxCall.ajaxListenerMethod;
        }

        if (jsonObj.ajaxCall.hasOwnProperty('ajaxRender')) {
          ajaxRender = jsonObj.ajaxCall.ajaxRender;
        }

        mandatoryComplex = '';
        if (jsonObj.ajaxCall.hasOwnProperty('immediate') && jsonObj.ajaxCall.immediate == false) {
          immediate = false;
        }

        if (jsonObj.ajaxCall.hasOwnProperty('mandatoryComplex') && jsonObj.ajaxCall.mandatoryComplex.hasOwnProperty('referenceID')) {

          mandatoryComplex = jsonObj.ajaxCall.mandatoryComplex.referenceID;
        }

        if (jsonObj.hasOwnProperty('navigationRule') && jsonObj.navigationRule != "" && method != "" && jsonObj.id != undefined && jsonObj.id != "") {
          layoutObject[jsonObj.id + "_" + method] = jsonObj.navigationRule;
        }

        if (jsonObj.hasOwnProperty('isRuleSensitive') && jsonObj.isRuleSensitive == true && method != "" && jsonObj.id != undefined && jsonObj.id != "") {
          layoutObject[jsonObj.id + "_rules" + method] = jsonObj.ruleBean;
        }

        if (jsonObj.ajaxCall.hasOwnProperty('actionParams')) {
          if (jsonObj.ajaxCall.actionParams.hasOwnProperty('actionParam')) {
            params = this.generateActionParamSessionStorageData(jsonObj);
          }
        }

        if (jsonObj.ajaxCall.hasOwnProperty('ajaxEvent')) {
          this.commonChangePage($event, method, method_type, layoutObject['pageName'], params, immediate, ajaxRender, fullData, jsonObj['beanClass'], ajaxSectionIds, ajaxAddRemoveElems, ajaxAddIds, jsonObj['id'], this.listVarCount, renderSec, refValue, undefined, undefined, mandatoryComplex, formChanged, confirmObj["isConfirm"], confirmObj["confirmMessage"], undefined, undefined);
        }
      }
    }
    //#endregion

    //#region isJsEvent
    else if (jsonObj.hasOwnProperty('isJsEvent') && jsonObj.isJsEvent == true) {

      if (jsonObj.hasOwnProperty('jsEventDetails')) {
        var targetBeanCountBeanClass = undefined;
        var targetBeanCountBeanId = undefined;
        if (jsonObj.hasOwnProperty('targetBeanCountDetails')) {
          if (jsonObj.targetBeanCountDetails.hasOwnProperty('beanClass') && jsonObj.targetBeanCountDetails.hasOwnProperty('beanId')) {
            targetBeanCountBeanClass = jsonObj.targetBeanCountDetails.beanClass;
            targetBeanCountBeanId = jsonObj.targetBeanCountDetails.beanId;
          }
        }

        if (jsonObj.jsEventDetails.hasOwnProperty('baseBeanDetails') && jsonObj.jsEventDetails.hasOwnProperty('targetBeanDetails')) {

          if ((jsonObj.jsEventDetails.baseBeanDetails.hasOwnProperty('beanClass') && jsonObj.jsEventDetails.baseBeanDetails.hasOwnProperty('beanId')) && (jsonObj.jsEventDetails.targetBeanDetails.hasOwnProperty('beanClass') && jsonObj.jsEventDetails.targetBeanDetails.hasOwnProperty('beanId'))) {

            if (jsonObj.jsEventDetails.hasOwnProperty('jsEvent') && jsonObj.jsEventDetails.jsEvent == 'add') {

              if (jsonObj.jsEventDetails.hasOwnProperty('selectedRowTableId')) {

                this.addRow(jsonObj.jsEventDetails.baseBeanDetails.beanClass, jsonObj.jsEventDetails.baseBeanDetails.beanId, jsonObj.jsEventDetails.targetBeanDetails.beanClass, jsonObj.jsEventDetails.targetBeanDetails.beanId, jsonObj.jsEventDetails.removeFromBase, jsonObj.jsEventDetails.selectedRowTableId, targetBeanCountBeanClass, targetBeanCountBeanId);
              } else {
                this.addRow(jsonObj.jsEventDetails.baseBeanDetails.beanClass, jsonObj.jsEventDetails.baseBeanDetails.beanId, jsonObj.jsEventDetails.targetBeanDetails.beanClass, jsonObj.jsEventDetails.targetBeanDetails.beanId, jsonObj.jsEventDetails.removeFromBase, undefined, targetBeanCountBeanClass, targetBeanCountBeanId);
              }

            } else if (jsonObj.jsEventDetails.hasOwnProperty('jsEvent') && jsonObj.jsEventDetails.jsEvent == 'delete') {
              this.addRow(jsonObj.jsEventDetails.baseBeanDetails.beanClass, jsonObj.jsEventDetails.baseBeanDetails.beanId, jsonObj.jsEventDetails.targetBeanDetails.beanClass, jsonObj.jsEventDetails.targetBeanDetails.beanId, jsonObj.jsEventDetails.removeFromBase, jsonObj.jsEventDetails.selectedRowTableId, targetBeanCountBeanClass, targetBeanCountBeanId);
            }
          }
        }
      } else if (jsonObj.hasOwnProperty('resetBeanDetails')) {
        if (jsonObj.resetBeanDetails.hasOwnProperty('resetBeans')) {
          if (jsonObj.resetBeanDetails.resetBeans.resetBean) {
            this.resetFields(jsonObj);
          }
        }
      }
    }
    //#endregion 

    //#region actionListenerMethod
    else if (jsonObj.hasOwnProperty('actionListenerMethod')) {
      var method = '';
      if (jsonObj.hasOwnProperty('actionListenerMethod')) {
        method = jsonObj.actionListenerMethod;
      }

      if (jsonObj.hasOwnProperty('navigationRule') && jsonObj.navigationRule != "" && method != "" && jsonObj.id != undefined && jsonObj.id != "") {
        layoutObject[jsonObj.id + "_" + method] = jsonObj.navigationRule;
      }

      var ajax_next_params = "";
      if (jsonObj.hasOwnProperty('actionListenerMethod')) {
        method = jsonObj.actionListenerMethod;
      }

      if (jsonObj.hasOwnProperty('actionParams')) {

        if (jsonObj.actionParams.hasOwnProperty('actionParam')) {
          params = this.generateActionParamSessionStorageData(jsonObj);
        }
      }

      if (jsonObj.actionListenerMethod == "lockMethod" || jsonObj.actionListenerMethod == "unlockMethod") {
        this.commonChangePage($event, method, method_type, layoutObject['pageName'], params, immediate, ajaxRender, fullData, jsonObj['beanClass'], ajaxSectionIds, ajaxAddRemoveElems, ajaxAddIds, jsonObj['id'], this.listVarCount, renderSec, refValue, undefined, undefined, mandatoryComplex, formChanged, confirmObj["isConfirm"], confirmObj["confirmMessage"], undefined, undefined);
      } else {
        //this.updatedNextPage($event, method, method_type, layoutObject['pageName'], ajax_next_params, immediate, true, mandatoryComplex, jsonObj.id, this.simpleElementBeanClass, this.commonProp.listVarCount, formChanged);
        this.commonChangePage($event, method, method_type, layoutObject['pageName'], params, immediate, ajaxRender, fullData, jsonObj['beanClass'], ajaxSectionIds, ajaxAddRemoveElems, ajaxAddIds, jsonObj['id'], this.listVarCount, renderSec, refValue, undefined, undefined, mandatoryComplex, formChanged, confirmObj["isConfirm"], confirmObj["confirmMessage"], undefined, undefined);
      }
    }
    //#endregion


    if (this.worklistIcon == true) {


    } else if (this.tableFlag) {
      var label_show = "";
      if (jsonObj.hasOwnProperty("label")) {
        label_show = jsonObj.label;
      }

      this.columnList += '<option value="' + jsonObj.beanId + '">' + label_show
        + '</option>';


    } else if (this.headerFlag == true) {

      /***********************************************************************
       * Start of New methodology
       */
      var formChanged = false;
      if ((jsonObj.hasOwnProperty('formChanged') && jsonObj.formChanged == true)
        && (jsonObj.hasOwnProperty('ajaxCall')
          && jsonObj.ajaxCall.hasOwnProperty('formChanged') && jsonObj.ajaxCall.formChanged == true)) {
        formChanged = true;
      }
      if (jsonObj.hasOwnProperty('actionParams')) {
        if (jsonObj.actionParams.hasOwnProperty('actionParam')) {
          this.generateActionParamSessionStorageData(jsonObj);
        }
      }

      if (jsonObj.hasOwnProperty('isAjaxCall') && jsonObj.isAjaxCall == true) {
        if (jsonObj.hasOwnProperty('ajaxCall')) {
          if (jsonObj.hasOwnProperty('navigationRule') && jsonObj.navigationRule != "" && method != "" && jsonObj.id != undefined && jsonObj.id != "") {
            layoutObject[jsonObj.id + "_" + method] = jsonObj.navigationRule;
          }

          if (jsonObj.ajaxCall.hasOwnProperty('actionParams')) {
            if (jsonObj.ajaxCall.actionParams.hasOwnProperty('actionParam')) {
              this.generateActionParamSessionStorageData(jsonObj);
            }
          }
        }
      }

      var formChanged = false;
      if ((jsonObj.hasOwnProperty('formChanged') && jsonObj.formChanged == true)
        && (jsonObj.hasOwnProperty('ajaxCall')
          && jsonObj.ajaxCall.hasOwnProperty('formChanged') && jsonObj.ajaxCall.formChanged == true)) {
        formChanged = true;
      }

      var data_slider = false;
      if (jsonObj.hasOwnProperty('slider') && jsonObj.slider == true) {
        data_slider = true;
      }


      /** End of New Methodology* */

    } else if (jsonObj.hasOwnProperty("isFloating") && jsonObj.isFloating == true) {

      if (jsonObj.hasOwnProperty("floating")
        && jsonObj.floating.hasOwnProperty("referenceID")) {
        var label_show = "";
        if (jsonObj.hasOwnProperty("label")) {

          label_show = jsonObj.label;
        }


      }
    } else if (this.dynamicElements == true) {
      this.updatedString += '';
    } else if (this.toggleData == true) {

      this.cnt_toggle++;
    }

    /** * Start of Javascript ** */
    if (jsonObj.hasOwnProperty("jsDetails")) {
      //this.updatedString += commonJavascriptMethod(jsonObj, layoutObject);
    }
    /** * End of Javascript ** */
  }

  generateActionParamSessionStorageData(jsonObj: any) {
    var ajax_params = '';
    var params = '';

    var actionParamArray;
    if (jsonObj.hasOwnProperty('ajaxCall') && jsonObj.ajaxCall.hasOwnProperty('actionParams')) {
      actionParamArray = jsonObj.ajaxCall.actionParams.actionParam;
    } else if (jsonObj.hasOwnProperty('actionParams')) {
      actionParamArray = jsonObj.actionParams.actionParam;
    }

    for (var i = 0; i < actionParamArray.length; i++) {

      var paramObj = actionParamArray[i];
      if (ajax_params == undefined || ajax_params == "undefined") {
        ajax_params = "";
      }

      if (paramObj.hasOwnProperty('beanClass')) {
        if (paramObj.hasOwnProperty('paramName')) {
          if (paramObj.hasOwnProperty('paramName')
            && paramObj.hasOwnProperty('listVarId')) {
            if (this.layoutObject.responseData.ValueJson != "" && this.layoutObject.responseData.ValueJson[paramObj.beanClass] != undefined && this.layoutObject.responseData.ValueJson[paramObj.beanClass][paramObj.listVarId] != undefined) {
              var myCount = 0;
              this.layoutObject.responseData.ValueJson[paramObj.beanClass][paramObj.listVarId].forEach((y, x) => {

                if (y.hasOwnProperty(paramObj.paramValue)) {
                  var sessionObject = {
                    "paramName": paramObj.paramName,
                    "listVarId": paramObj.listVarId,
                    "sessionBeanClass": paramObj.beanClass,
                    "sessionBeanId": paramObj.paramValue,
                    "value": y[paramObj.paramValue]
                  };
                } else {
                  var sessionObject = {
                    "paramName": paramObj.paramName,
                    "listVarId": paramObj.listVarId,
                    "sessionBeanClass": paramObj.beanClass,
                    "sessionBeanId": paramObj.paramValue,
                    "value": y
                  };
                }
                // set that object
                // in session
                sessionStorage
                  .setItem(
                    "list_"
                    + paramObj.beanClass
                    + "_"
                    + paramObj.listVarId
                    + "_"
                    + paramObj.paramValue
                    + "_"
                    + myCount,
                    JSON.stringify(sessionObject));
                myCount++;
              });
            } else {

              // create object to store bean class and
              // bean id in session
              var sessionObject = {
                "paramName": paramObj.paramName,
                "listVarId": paramObj.listVarId,
                "sessionBeanClass": paramObj.beanClass,
                "sessionBeanId": paramObj.paramValue
              };
              // set that object in session
              sessionStorage.setItem("list_"
                + paramObj.beanClass + "_"
                + paramObj.paramValue, JSON.stringify(sessionObject));
            }
          } else {
            // create object to store bean class and
            // bean id in session
            var sessionObjects = {
              "paramName": paramObj.paramName,
              "sessionBeanClass": paramObj.beanClass,
              "sessionBeanId": paramObj.paramValue
            };
            // set that object in session
            sessionStorage.setItem(paramObj.beanClass
              + "_" + paramObj.paramValue, JsonPipe.prototype.transform(sessionObjects));
          }
        }

        if (this.complexListVarId != "") {

          if (this.layoutObject.responseData.ValueJson != ""
            && this.layoutObject.responseData.ValueJson[paramObj.beanClass] && this.layoutObject.responseData.ValueJson[paramObj.beanClass][this.complexListVarId]) {
            if (paramObj.hasOwnProperty('listVarId')) {

              if (this.layoutObject.responseData.ValueJson[paramObj.beanClass][this.complexListVarId] && this.layoutObject.responseData.ValueJson[paramObj.beanClass][this.complexListVarId].length > 0) {
                params += ""
                  + paramObj.beanClass
                  + "_"
                  + paramObj.listVarId
                  + "_"
                  + paramObj.paramValue
                  + "="
                  + this.layoutObject.responseData.ValueJson[paramObj.beanClass][this.complexListVarId][this.listVarCount][paramObj.paramValue];
              }

            } else {
              params += ""
                + paramObj.beanClass
                + "_"
                + paramObj.paramValue
                + "="
                + this.layoutObject.responseData.ValueJson[paramObj.beanClass][paramObj.paramValue];;
            }
          }
        } else {

          if (paramObj.hasOwnProperty('listVarId')) {

            if (this.layoutObject.responseData.ValueJson != ""
              && this.layoutObject.responseData.ValueJson[paramObj.beanClass]) {
              params += ""
                + paramObj.beanClass
                + "_"
                + paramObj.listVarId
                + "_"
                + paramObj.paramValue
                + "="
                + this.layoutObject.responseData.ValueJson[paramObj.beanClass][paramObj.paramValue];
            }
          } else {
            if (this.layoutObject.responseData.ValueJson != ""
              && this.layoutObject.responseData.ValueJson[paramObj.beanClass]) {
              params += ""
                + paramObj.beanClass
                + "_"
                + paramObj.paramValue
                + "="
                + this.layoutObject.responseData.ValueJson[paramObj.beanClass][paramObj.paramValue];
            }
          }
        }
      } else if (paramObj.hasOwnProperty('valueType')) {

        if (paramObj.valueType == "constant") {

          params += paramObj.paramName + "="
            + paramObj.paramValue;
        } else {

          params += paramObj.paramName + "="
            + jsonObj[paramObj.valueType];
        }
      } else {

        params += paramObj.paramName + "="
          + paramObj.paramValue;
      }

      if (i < (actionParamArray.length - 1)) {

        params += "&";
      }
    }

    return params;
  }

  commonChangePage($event, methodName, methodType, myPageName, params, immediate, ajaxRender, fullData, eleBeanClass, sectionIds, removeElements, addElements, id, listVarCount, renderSection, referenceValue, expandRowId, rowExpandTblBeanId, mandatoryComplex, formChanged, isConfirm, confirmMsg, isSectionLoad, isPopupOpen) {
    let objParam = {
      'methodName': methodName,
      'methodType': methodType,
      'myPageName': myPageName,
      'params': params,
      'immediate': immediate,
      'ajaxRender': ajaxRender,
      'fullData': fullData,
      'eleBeanClass': eleBeanClass,
      'sectionIds': sectionIds,
      'removeElements': removeElements,
      'addElements': addElements,
      'id': id,
      'listVarCount': listVarCount,
      'renderSection': renderSection,
      'referenceValue': referenceValue,
      'expandRowId': expandRowId,
      'rowExpandTblBeanId': rowExpandTblBeanId,
      'mandatoryComplex': mandatoryComplex,
      'formChanged': formChanged,
      'isConfirm': isConfirm,
      'confirmMsg': confirmMsg,
      'isSectionLoad': isSectionLoad,
      'isPopupOpen': isPopupOpen
    }

    this.clickEvent.emit(objParam);
  }
}
